/**
 * The `matter:{recordId}` channel (MatterRoom, worker/src/matter-room.js): forecast and roll-call deltas for one
 * legislation record, re-dispatched as the window event `matter:delta` that LegislationDetail listens to.
 * Opens after first paint; LiveChannel replays what was missed ({type:"hello", lastSeq}).
 */
import { LiveChannel } from "./liveClient";
import type { LegislationDelta } from "../legislation/types";

export function connectMatter(recordId: string, getLastSeq: () => number): () => void {
  if (typeof WebSocket === "undefined") return () => {};
  const channel = new LiveChannel({
    url: `${location.protocol === "https:" ? "wss" : "ws"}://${location.host}/live/matter/${encodeURIComponent(recordId)}`,
    channel: `matter:${recordId}`,
    getLastSeq,
    onSnapshot: () => {},
    onDelta: (seq, delta) => dispatchEvent(new CustomEvent("matter:delta", { detail: { seq, delta: delta as unknown as LegislationDelta } })),
  });
  const start = () => channel.start();
  if ("requestIdleCallback" in window) requestIdleCallback(start, { timeout: 1500 }); else setTimeout(start, 300);
  return () => channel.stop();
}
